export const usePlatform = () => {
	let isMac = false;
	let isWindows = false;
	let isLinux = false;

	// TODO: Refactor this hook when navigator.userAgentData is more widely supported
	if (!(navigator as any).userAgentData) {
		const platform = navigator.platform.toLowerCase();
		isMac = platform.includes("mac");
		isWindows = platform.includes("win");
		isLinux = platform.includes("linux");
	} else {
		const platform = (navigator as any).userAgentData.platform.toLowerCase();
		isMac = platform.includes("mac");
		isWindows = platform.includes("win");
		isLinux = platform.includes("linux");
	}

	return { isMac, isWindows, isLinux };
};
